import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';

import '@here/maps-api-for-javascript';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-new-map',
  standalone: false,
  templateUrl: './new-map.component.html',
  styleUrl: './new-map.component.scss',
})
export class NewMapComponent implements AfterViewInit {
  @Input() public zoom = 12;
  @Input() public lat = -12.0464;
  @Input() public lng = -77.0428;

  private map?: H.Map;
  private marker?: H.map.Marker;

  @ViewChild('map') mapDiv?: ElementRef;

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.map) {
      return;
    }

    if (changes['zoom']) {
      this.map.setZoom(this.zoom);
    }

    if (changes['lat'] || changes['lng']) {
      const position = {
        lat: this.lat,
        lng: this.lng,
      };

      this.map.setCenter(position);
      this.map.setZoom(17);

      if (this.marker) {
        this.marker.setGeometry(position);
      } else {
        this.marker = new H.map.Marker(position);
        this.map.addObject(this.marker);
      }
    }
  }

  ngAfterViewInit(): void {
    if (!this.map && this.mapDiv) {
      const platform = new H.service.Platform({
        apikey: environment.hereMapsApiKey,
      });

      const layers = platform.createDefaultLayers();

      this.map = new H.Map(
        this.mapDiv.nativeElement,
        (layers as any).vector.normal.map,
        {
          pixelRatio: window.devicePixelRatio,
          center: {
            lat: this.lat,
            lng: this.lng,
          },
          zoom: this.zoom,
        },
      );

      const mapEvents = new H.mapevents.MapEvents(this.map);

      new H.mapevents.Behavior(mapEvents);
      const ui = H.ui.UI.createDefault(this.map, layers);

      const zoomControl = ui.getControl('zoom');

      if (zoomControl) {
        zoomControl.setAlignment(H.ui.LayoutAlignment.RIGHT_BOTTOM);
      }

      const mapSettingsControl = ui.getControl('mapsettings');

      if (mapSettingsControl) {
        mapSettingsControl.setVisibility(false);
      }

      this.marker = new H.map.Marker({
        lat: this.lat,
        lng: this.lng,
      });

      this.map.addObject(this.marker);
    }
  }

  public resetToLocation(
    lat: number,
    lng: number,
    zoom: number,
  ): void {
    if (!this.map) {
      return;
    }

    const position = { lat, lng };

    this.map.setCenter(position);
    this.map.setZoom(zoom);

    if (this.marker) {
      this.marker.setGeometry(position);
    } else {
      this.marker = new H.map.Marker(position);
      this.map.addObject(this.marker);
    }
  }
}